import React, {Component} from "react";
import PackageItem from './PackageItem';
import PropTypes from 'prop-types';

class Packages extends Component {
    render() {

        // console.log('packages', this.props.packages)
        
        return ( <div>{this.props.packages && this.props.packages.map((packageItem) => (
            <PackageItem key={packageItem.post_id} packageItem={packageItem} location_id={this.props.location_id}/>
        ))}

        {!this.props.packages && <div>LOADING....</div>}
        </div>);
    }
}

// Good Practice
Packages.propTypes = {
    packages: PropTypes.array.isRequired
}

export default Packages;